import _ from 'lodash';
import { useState } from 'react';
import { connect } from 'react-redux';

const formatNumber = (value) => parseFloat(value || 0).toLocaleString(navigator.language, { minimumFractionDigits: 3 });

const EmissionsBySourceRow = ({
  id,
  org,
  option,
  report,
  entity,
  facility,
  adminOrgs,
  subentity,
  usageDetail,
  includedOrgs,
}) => {
  const [expandedRows, setExpandedRows] = useState(new Set());
  const toggleRow = (id) => {
    setExpandedRows((prevExpandedRows) => {
      const newExpandedRows = new Set(prevExpandedRows);
      if (newExpandedRows.has(id)) {
        newExpandedRows.delete(id);
      } else {
        newExpandedRows.add(id);
      }
      return newExpandedRows;
    });
  };

  //Option is the consumption data for the year for that specific entity and subentity... i.e Consumption State -> Data[entityID][subentityID][entityID_subentityID_metric]._allFacilities
  if (!report) return null;
  const year = report.year;
  const hasMarketFactors = option?.[org]?.[year] && (option?.[org][year].co2e_market || option?.[org][year].market_mix);
  if (includedOrgs?.length > 0) {
    if (usageDetail?.length > 0 && !usageDetail[0]?.includes('Organisation:')) {
      usageDetail = ['Organisation: ' + adminOrgs?.find((o) => o.id === org)?.name, <br />].concat(usageDetail);
    } else {
      usageDetail.push(['Organisation: ' + adminOrgs?.find((o) => o.id === org)?.name]);
    }
  }
  return [
    <tr
      key={id}
      className={`table-values ${facility ? `facility-values toggle-facility-${facility.id}` : ''} ${
        hasMarketFactors ? `toggle-location` : ''
      } ${`title-subrow-${entity?.name?.split(' ').join('').replace(':', '-')}`}`}>
      <td className='text-left bg-background p-[8px]'>
        <div className='hidden sm:table-cell'>
          {subentity.name}
          <span className='usage-detail text-muted-foreground ml-2'>{usageDetail}</span>
        </div>
        <div className='flex sm:hidden flex-col'>
          {subentity.name}
          {expandedRows.has(id) && <span className='usage-detail text-muted-foreground ml-2'>{usageDetail}</span>}
        </div>
      </td>
      <td className='text-right p-[8px]'>
        <div className='hidden sm:block'>
          {formatNumber(option?.[org]?.[year] ? _.sum(Object.values(option[org][year].scope)) : 0)}
        </div>
        <div className='flex sm:hidden flex-col justify-end'>
          {formatNumber(option?.[org]?.[year] ? _.sum(Object.values(option[org][year].scope)) : 0)}
          <button className='text-xs text-primary underline mt-1' onClick={() => toggleRow(id)}>
            {expandedRows.has(id) ? 'Hide Details' : 'View Details'}
          </button>
          {expandedRows.has(id) && (
            <span className='usage-detail normal-case block sm:hidden text-muted-foreground'>
              <p>Scope 1 (tCO2e): {formatNumber(option?.[org]?.[year] ? option[org][year].scope[1] : 0)}</p>
              <p>Scope 2 (tCO2e): {formatNumber(option?.[org]?.[year] ? option[org][year].scope[2] : 0)}</p>
              <p>Scope 3 (tCO2e incl. WTT*): {formatNumber(option?.[org]?.[year] ? option[org][year].scope[3] : 0)}</p>
            </span>
          )}
        </div>
      </td>
      <td className='hidden sm:table-cell text-right p-[8px]'>{formatNumber(option?.[org]?.[year] ? option[org][year].scope[1] : 0)}</td>
      <td className='hidden sm:table-cell text-right p-[8px]'>{formatNumber(option?.[org]?.[year] ? option[org][year].scope[2] : 0)}</td>
      <td className='hidden sm:table-cell text-right p-[8px]'>{formatNumber(option?.[org]?.[year] ? option[org][year].scope[3] : 0)}</td>
    </tr>,

    hasMarketFactors ? (
      <tr
        key={crypto.randomUUID()}
        className={`table-values ${facility ? `facility-values toggle-facility-${facility.id}` : ''} toggle-market`}>
        <td className='text-left bg-background p-[8px]'>
          <div className='hidden sm:table-cell'>
            {subentity.name} <span className='usage-detail text-muted-foreground ml-2'>{usageDetail}</span>
          </div>
          <div className='flex sm:hidden flex-col'>
            {subentity.name}
            {expandedRows.has(id) && <span className='usage-detail text-muted-foreground ml-2'>{usageDetail}</span>}
          </div>
        </td>
        <td className='text-right p-[8px]'>
          <div className='hidden sm:block'>
            {formatNumber(
              option?.[org]?.[year] && option[org][year].scopeMarket
                ? _.sum(Object.values(option[org][year].scopeMarket))
                : 0,
            )}
          </div>
          <div className='flex sm:hidden flex-col justify-end'>
            {formatNumber(
              option?.[org]?.[year] && option[org][year].scopeMarket
                ? _.sum(Object.values(option[org][year].scopeMarket))
                : 0,
            )}
            <button className='text-xs text-primary underline mt-1' onClick={() => toggleRow(id)}>
              {expandedRows.has(id) ? 'Hide Details' : 'View Details'}
            </button>
            {expandedRows.has(id) && (
              <span className='usage-detail normal-case block sm:hidden text-muted-foreground'>
                <p>Scope 1 (tCO2e): {formatNumber(option?.[org]?.[year] ? option[org][year].scopeMarket[1] : 0)}</p>
                <p>Scope 2 (tCO2e): {formatNumber(option?.[org]?.[year] ? option[org][year].scopeMarket[2] : 0)}</p>
                <p>
                  Scope 3 (tCO2e incl. WTT*): {formatNumber(option?.[org]?.[year] ? option[org][year].scopeMarket[3] : 0)}
                </p>
              </span>
            )}
          </div>
        </td>
        <td className='hidden sm:table-cell text-right p-[8px]'>
          {formatNumber(option?.[org]?.[year] && option[org][year].scopeMarket ? option[org][year].scopeMarket[1] : 0)}
        </td>
        <td className='hidden sm:table-cell text-right p-[8px]'>
          {formatNumber(option?.[org]?.[year] && option[org][year].scopeMarket ? option[org][year].scopeMarket[2] : 0)}
        </td>
        <td className='hidden sm:table-cell text-right p-[8px]'>
          {formatNumber(option?.[org]?.[year] && option[org][year].scopeMarket ? option[org][year].scopeMarket[3] : 0)}
        </td>
      </tr>
    ) : null,
  ];
};

const mapStateToProps = (state) => {
  const { years } = state.consumption;

  const { organisation, metric, report } = state;
  const adminOrgs = state.admin?.organisations;
  const organisationList = state.organisation?.list;
  const { cyfAdmin, whiteLabelAdmin } = state.profile?.details || {};
  const adminUser = cyfAdmin || whiteLabelAdmin || false;

  return {
    years: years || [],
    organisationDetails: organisation?.details,
    metricValues: organisation?.metrics ? organisation?.metrics : null,
    metrics: metric?.list,
    report: report?.details,
    adminOrgs: adminUser ? adminOrgs : organisationList,
    includedOrgs: state?.report?.includedOrgs,
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(EmissionsBySourceRow);
